import { render, staticRenderFns } from "./SectionFormCard.vue?vue&type=template&id=a7be2bb8&scoped=true&"
import script from "./SectionFormCard.vue?vue&type=script&lang=js&"
export * from "./SectionFormCard.vue?vue&type=script&lang=js&"
import style0 from "./SectionFormCard.vue?vue&type=style&index=0&id=a7be2bb8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7be2bb8",
  null
  
)

export default component.exports